import { MutationTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertySmoovedTypesStore from "./property-smooved-types.store";
import { ISmoovedInfoResponseModel, SmoovedConnectionModel, SmoovedRequestModel, ISmoovedConnectionModel } from "../../../../models/property/property-smooved.model";
import Vue from "vue";
import { KeuringsPlatformInfoModel, IKeuringsPlatformInfoModel } from "../../../../models/property/property-keuring-platform.model";

const smoovedMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
  [propertySmoovedTypesStore.Set.SMOOVED_REQUEST_INFO]: (
    state: IPropertyEditState,
    param: ISmoovedInfoResponseModel
  ) => {
    // state.smooved.PrimaryContact = param.ContactInfos[0] ? deepClone(param.ContactInfos[0]) : new KeuringsPlatformInfoModel({});
    state.smooved.PropertyAddress = param.PropertyAddress;
    state.smooved.PropertyHouseNumber = param.PropertyHouseNumber;
    state.smooved.PropertyPostCode = param.PropertyPostCode;
    state.smooved.PropertyCityName = param.PropertyCityName;
    state.smooved.PropertyCountryId = param.PropertyCountryId;
    state.smooved.PropertyBoxNumber = param.PropertyBoxNumber;
    state.smooved.Bedrooms = param.Bedrooms;
    state.smooved.LivingRooms = param.LivingRooms;
    state.smooved.Bathrooms = param.Bathrooms;
    state.smooved.Attics = param.Attics;
    state.smooved.ParkingSpotsInGarage = param.ParkingSpotsInGarage;
    state.smooved.ConstructionYear = param.ConstructionYear;
    state.smooved.Connection.IsGas = param.IsGas;
    state.smooved.PropertyType = param.PropertyType;
    //console.log(state.smooved);
  },

  [propertySmoovedTypesStore.Set.SMOOVED_ASSIGN_VALUE]: (state: IPropertyEditState, smooved: SmoovedRequestModel) => {
    Object.keys(smooved).forEach(key => Vue.set(state.smooved, key, smooved[key]))
  },

  [propertySmoovedTypesStore.Set.PRIMARY_CONTACT_ASSIGNVALUE]: (state: IPropertyEditState, smooved: IKeuringsPlatformInfoModel) => {
    Object.keys(smooved).forEach(key => Vue.set(state.smooved.PrimaryContact, key, smooved[key]))
  },

  [propertySmoovedTypesStore.Set.PRIMARY_CONTACT_RESET]: (state: IPropertyEditState) => {
    state.smooved.PrimaryContact = new KeuringsPlatformInfoModel({});
  },

  // [propertySmoovedTypesStore.Set.SECONDARY_CONTACT_ASSIGNVALUE]: (state: IPropertyEditState, smooved: IKeuringsPlatformInfoModel) => {
  //   Object.keys(smooved).forEach(key => Vue.set(state.smooved.SecondaryContact, key, smooved[key]))
  // },

  // [propertySmoovedTypesStore.Set.SECONDART_CONTACT_RESET]: (state: IPropertyEditState) => {
  //   state.smooved.SecondaryContact = new KeuringsPlatformInfoModel({});
  // },

  [propertySmoovedTypesStore.Set.LEAVING_CUSTOMER_ASSIGNVALUE]: (state: IPropertyEditState, smooved: IKeuringsPlatformInfoModel) => {
    Object.keys(smooved).forEach(key => Vue.set(state.smooved.LeavingCustomer, key, smooved[key]))
  },

  [propertySmoovedTypesStore.Set.LEAVING_CUSTOMER_RESET]: (state: IPropertyEditState) => {
    state.smooved.LeavingType = null;
    state.smooved.LeavingCustomer = new KeuringsPlatformInfoModel({});
  },

  [propertySmoovedTypesStore.Set.CONNECTION_ASSIGNVALUE]: (state: IPropertyEditState, smooved: ISmoovedConnectionModel) => {
    Object.keys(smooved).forEach(key => Vue.set(state.smooved.Connection, key, smooved[key]))
  },

  [propertySmoovedTypesStore.Set.CONNECTION_RESET]: (state: IPropertyEditState) => {
    state.smooved.Connection = new SmoovedConnectionModel({});
  }
};

export default smoovedMutations;
